export const TABS = {
  GENERAL: "general",
  DEPLOYMENT: "deployment",
  ANALYTICS: "analytics"
};

export const PAGE_TITLE = "Agent settings";

// The logical channels benchmarks are defined for, as stored in Snowflake's BENCHMARKS_*
// tables. Deliberately NOT derived from CHANNEL_TO_DISPLAY_NAME: that is a UI label map,
// and these values travel over the wire as what data-service filters on
// (WHERE bd.CHANNEL = ?). Relabelling "Chat" in the UI must not silently empty every chat
// agent's benchmarks table.
export const ASSISTANT_CHANNEL_TO_BENCHMARK_CHANNEL = {
  Phone: "Voice",
  Voice: "Voice",
  Web: "Chat"
};

export const BENCHMARK_CHANNELS = [...new Set(Object.values(ASSISTANT_CHANNEL_TO_BENCHMARK_CHANNEL))];

// The benchmark setups (Action / Action scheduling / Routing / Q&A) describe voice
// call-handling shapes, so chat agents all sit on the single default setup and have no
// choice to make — the setup selector is hidden for them.
export const CHAT_CHANNEL = "Chat";
